<template lang="pug">
//- **
//- * 共通 - HEADER
//- * @components
//- **

header.l_header(v-scroll="toShrinkTheHeader")
  .p_h.c_col.u_col-ai-c.u_col-jc-sb(ref="heightTheHeader")
    .c_col-pc.u_col-ai-c.u_col-jc-sb.c_inner-pc
      .p_h-l
        .c_inner-sp
          .c_col.u_col-ai-c(ref="logo")
            router-link.p_h-l-logo(to="/" @click.native="scrollToTop(), close(0)", v-touch="true")
              span.-image: img(:src="getImage('/common', '/h_logo.png', '')", alt="ALH｜AZ LEADING HARMONIZER")
              //- span.-scroll(ref="fadeInTheLogo"): img(:src="getImage('/common', '/h_logo2.svg', '')", alt="")
      .p_h-r
        transition(@enter="enter", @leave="leave", :css="false")
          .p_h-r-navi(v-show="!$store.state.isSmartPhone || show" ref="naviList")
            nav.p_h_navi(@click="show = !show")
              .p_h_navi-bar(ref="bar"): span.-bar

              .p_h_navi-list.c_col-pc
                .p_h_vr(v-if="$store.state.isSmartPhone")
                  .c_inner
                      a.p_vpanel.p_h_vr-inner(href="https://my.matterport.com/show/?m=TsQ6iijtmLN", target="_blank", v-touch:tap="tap")
                        .p_vpanel-inner.c_col.u_col-ai-c
                          .p_vpanel-inner-content
                            .p_vpanel-header
                              h2.p_vpanel-heading
                                span.-text ALH Office Tour
                            .p_vpanel-body
                              h3.p_vpanel-body-heading
                                span.-text 360°動画でオフィス見学する
                              .p_vpanel-body-text
                                p このサイトではALH株式会社のオフィスにいるかのようなウォークスルー体験ができます。
                              .p_vpanel-footer
                                p.p_vpanel-more.c_col.u_col-ai-c
                                  span.-text View more
                                  i.-bar
                ul.p_h_navi-list-content.c_col-pc(v-if="$store.state.isSmartPhone")
                  li.p_h_navi-list-item(:class="{current: $store.state.navi.currentPos === k}",
                    v-if="t.text !== 'VR Office tour'",
                    v-for="(t, k) in $store.state.navi.all" ref="naviItem")

                    //- forSP & PC
                    router-link.p_h_navi-link(:to="t.url",
                      @click.native="close(k)",
                      v-touch="true",
                      v-if="t.hash !== false"
                    )
                      span.p_h_navi-text {{t.text}}

                      i.p_h_navi-bar(v-bind:style="{ width: 'calc(100% - 48px)', left: 0, right: 0, margin: 'auto' }")
                        span.-bar

                    a.p_h_navi-link(:href="t.url",
                      @click.native="close(k)",
                      v-touch="true",
                      target="_blank",
                      v-else
                    )
                      span.p_h_navi-text {{t.text}}

                      i.p_h_navi-bar(v-bind:style="{ width: 'calc(100% - 48px)', left: 0, right: 0, margin: 'auto' }")
                        span.-bar


                ul.p_h_navi-list-content.c_col-pc(v-if="!$store.state.isSmartPhone")
                  li.p_h_navi-list-item(:class="{current: $store.state.navi.currentPos === k}",
                    v-for="(t, k) in $store.state.navi.all" ref="naviItem")

                    //- forSP & PC
                    router-link.p_h_navi-link.hover(:to="t.url",
                      @click.native="close(k)",
                      :blank="t.target", v-touch="true",
                      v-if="t.hash !== false"
                    )
                      span.p_h_navi-text {{t.text}}

                      i.p_h_navi-bar(v-bind:style="{ width: 'calc(100% - 48px)', left: 0, right: 0, margin: 'auto' }")
                        span.-bar
                    a.p_h_navi-link.hover(:href="t.url",
                      @click.native="close(k)",
                      v-touch="true",
                      target="_blank",
                      v-else
                    )
                      span.p_h_navi-text {{t.text}}

                      i.p_h_navi-bar(v-bind:style="{ width: 'calc(100% - 48px)', left: 0, right: 0, margin: 'auto' }")
                        span.-bar



      button.p_h_navi_btn.u_bl-sp(@click="show = !show")
        span.p_h_navi_btn-inner
          span.-open
            span.-naviBar(ref="naviBar")
            span.-before(ref="naviBarBefore")
            span.-after(ref="naviBarAfter")
</template>

<script>
import {  mapActions } from 'vuex'

export default {
  watch: {
    '$store.state.isSmartPhone': function () {
      this.show = (this.$store.state.isSmartPhone) ? false : true
    },
    show () {
      if (this.$store.state.isSmartPhone) {
        this.btn()
      }
    }
  },
  data () {
    return {
      navigations: {
        items: [],
        el: [],
      },
      naviItems: [],
      show: false,
      childShow: false,
      naviWidth: [],
      current: null,
      styleObj: {
        background: 'transparent'
      }
    }
  },
  mounted () {
    this.isSmartPhone()
    this.getSpDir()
  },
  methods: {
    ...mapActions(['isSmartPhone', 'getSpDir']),
    toShrinkTheHeader () {
      let refs = this.$refs
      let el = refs.heightTheHeader
      let logo = refs.logo
      let fadeInTheLogo = refs.fadeInTheLogo
      let speed = .3

      let styles = (0 < window.scrollY)
        ? {
            // background: 'rgba(0,0,0,.5)',
            height: 70,
          }
        : {
            // background: 'transparent',
            height: 'auto',
          }
      let logoStyles = (0 < window.scrollY) ? { scale: 0.9 } : { scale: 1 }
      let fadeInTheLogoStyles = (0 < window.scrollY) ? { opacity: 1 } : { opacity: 0 }

      let styleObj = {
        el: styles,
        logo: logoStyles,
        fadeInTheLogo: fadeInTheLogoStyles
      }

      TweenMax.to(el, speed, styleObj.el)
      TweenMax.to(logo, speed, Object.assign({ transformOrigin: 'left center' }, styleObj.logo))
      // TweenMax.to(fadeInTheLogo, speed, styleObj.fadeInTheLogo)

    },
    setStyleObjifSmartPhone () {
      // ナビゲーションの初期設定
      TweenMax.set(this.$refs.naviList, {
        scale: .9,
        autoAlpha: 0,
        ease: Power2.easeOut,
      })

      TweenMax.set(this.$refs.bar, {
        width: 0,
        overflow: 'hidden',
        autoAlpha: 0,
        ease: Power2.easeOut,
      })
    },
    btn () {
      let target = this.$refs.naviBar
      let before = this.$refs.naviBarBefore
      let after = this.$refs.naviBarAfter
      let time = .3

      let tlBefore = new TimelineLite()
      let tlAfter = new TimelineLite()

      if (this.show) {
        // SPメニュー　開いた時のハンバーガーメニューのアニメーション
        TweenLite.to(target, time, {
          autoAlpha: 0,
          ease: Power2.ease
        })
        tlBefore.to(before, time, {
          top: 7,
          ease: Power2.ease
        }).to(before, time, {
          rotation: 45,
          ease: Power2.ease
        })

        tlAfter.to(after, time, {
          bottom: 7,
          ease: Power2.ease
        }).to(after, time, {
          rotation: -45,
          ease: Power2.ease
        })

      } else {
        // SPメニュー　閉じた時のハンバーガーメニューのアニメーション
        TweenMax.to(target, time, {
          autoAlpha: 1,
          ease: Power2.ease
        })
        tlBefore.to(before, time, {
          rotation: 0,
          ease: Power2.ease
        }).to(before, time, {
          top: 0,
          ease: Power2.ease
        })

        tlAfter.to(after, time, {
          rotation: 0,
          ease: Power2.ease
        }).to(after, time, {
          bottom: 0,
          ease: Power2.ease
        })
      }
    },
    close (key) {
      if (this.$store.state.isSmartPhone) {
          // 閉じるときにも storeに現在地を知らせる
          this.$store.commit('NAVI_CURRENT_POS', key)
          //- サブメニューを閉じる
          // TweenMax.set(this.$refs.addChildHeight[0], {
          //   maxHeight: 0,
          // })
          // TweenMax.set(this.$refs.arrow[0], {
          //   rotation: 0,
          // })
          // this.childShow = false
      }
    },
    enter (el, done) {
      // SP メニューが開く時のアニメーション
      TweenMax.to(el, 0.4, {
        scale: 1,
        display: 'block',
        autoAlpha: 1,
      });
      if (this.$store.state.isSmartPhone) {
        document.querySelector('html').classList.add('overflow')
        this.styleObj = {
          background: '#fff'
        }
      }
    },
    leave (el, done) {
      // SP メニューが閉じる時のアニメーション
      TweenMax.to(el, 0.4, {
        scale: .9,
        display: 'none',
        autoAlpha: 0
      });

      this.styleObj = {
        background: 'transparent'
      }

      document.querySelector('html').classList.remove('overflow')
    },
  },
}
</script>

<style lang="scss" scoped>
.l_header {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  // background: rgba(#000,.4);
}

.p_h {
  @include pc {
    height: rem(128);
  }
  @include sp {
    // height: rem(172,2);
  }

  &-l {
    @include sp {
      width: 100%;
      position: relative;
      z-index: 1001;
    }

    &-logo {
      @include pc {
        width: rem(126);
      }
      @include sp {
        width: rem(240,2);
        padding: rem(20) 0 rem(10);
      }
      // width: calc(100% - 48px);
      display: block;
      line-height: 0;
      position: relative;

      .-image {
        display: block;
        position: relative;
      }
      .-scroll {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        opacity: 0;
      }

      img {}
    }
  }

  &-r {
    @include sp {
      position: relative;
      z-index: 1000;
      margin: rem(-75) 0 0;
    }

    &-navi {
    }
  }
}

.p_h_vr {
  @include sp {
    background: #fff;
    padding: rem(40+75) 0 rem(45);
  }

  &-inner {
    @include sp {
      @include box_shadow();
      background: $palet1;
    }
  }
}

.p_h_navi {
  @include sp {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    background: rgba(#000,.9);
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  position: relative;

  &-list {
    @include sp {
      overflow: auto;
      padding: 0 0 rem(200);
    }

    &-content {
      @include sp {
        padding: rem(15) 0 0;
      }
    }
    &-item {
    }
  }
  &-link {
    @include pc {
      font-size: rem(14);
      padding: rem(41) rem(24) rem(42);
    }
    @include sp {
      width: 100%;
      font-size: rem(20);
      padding: rem(18) 0;
      line-height: 1;
    }
    text-align: center;
    font-weight: bold;
    position: relative;

    &:not(.u_bl-sp) {
      display: block;
    }
  }

  // ナビゲーションバーのスライドアニメーションをしない場合
  &-link.hover {
    &.tap {
      @include pc {
        // color: $palet1;
      }
    }
  }

  &-link.hover &-bar .-bar {
    // opacity: 0;
    width: 0;
    transition: all .4s ease;
    position: absolute;
    right: 0;
    left: auto;
    background: #fff;
  }

  &-link.hover.tap &-bar .-bar {
    @include pc {
      width: 100%;
      opacity: 1;
      left: 0;
      right: auto;
    }
  }

  // スライドアニメーションありの場合
  &-bar {
    @include pc {
      height: 2px;
      display: block;
      position: absolute;
      bottom: rem(74,2);
    }

    .-bar {
      @include pc {
        @include box_shadow();
        width: calc(100% - 48px);
        height: 2px;
        background: #fff;
        display: block;
        margin: 0 auto;
      }
    }
  }


  &-text {
    @include sp {
      font-size: rem(36,2);
      letter-spacing: $ltsp2;
      padding: 0 0 rem(5);
    }
    @include pc {
      font-size: rem(12);
      letter-spacing: .2em;
      text-shadow: 0 0 1px #212121;
    }
    color: #fff;
    font-weight: 800;
    display: inline-block;
  }

  &-small {
    @include sp {
      display: block;
      color: #fff;
      font-size: rem(10);
      font-weight: bold;
      letter-spacing: $ltsp2;
      margin: rem(8) 0 0;
    }
  }

  // SPメニュー開閉ボタン
  &-button {
    @include pc {
      width: rem(140);
      padding: rem(8) rem(9);
      border-radius: rem(30);
    }
    background: $palet3;
    text-align: center;
    display: block;
    width: 100%;
    padding: rem(18);

    &-text {
      font-size: rem(12);
      color: $color;
      font-weight: bold;
    }
  }
}

.p_h_navi_btn {
  width: rem(60);
  height: rem(60);
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1001;

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
  }

  &-inner {
    width: rem(25);
    height: rem(15);
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .-open {
      width: 24px;
      height: 16px;
      position: absolute;
      display: block;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;

      .-naviBar {
        // width: 100%;
        // height: 2px;
        // border-radius: 3px;
        // position: absolute;
        // display: block;
        // left: 0;
        // top: 0;
        // bottom: 0;
        // margin: auto;
        // background: #fff;
      }

      .-before {
        width: 100%;
        height: 2px;
        border-radius: 3px;
        background: #fff;
        position: absolute;
        display: block;
        margin: auto;
        left: 0;
        top: 0;
      }
      .-after {
        width: 100%;
        height: 2px;
        border-radius: 3px;
        background: #fff;
        position: absolute;
        display: block;
        margin: auto;
        left: 0;
        bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue